<template>
  <div class="relative multi-select-sr" ref="containerRef">
    <div
        class="form-control p-2 cursor-pointer min-h-[40px] d-flex align-items-center justify-content-between"
        @click="open = !open"
    >
      <div class="flex flex-wrap gap-1">

        <!-- Selecionados -->
        <span
            style="margin: 1px"
            class="badge bg-faded-dark"
            v-for="item in selectedOptions"
            :key="item.value"
        >
        {{ item.label }}
        <Icon icon="ic:baseline-close" class="ms-1" @click.stop="remove(item.value)"/>
      </span>

        <span v-if="!modelValue.length" class="text-gray-400 text-sm">
        {{ placeholder }}
      </span>
      </div>

      <Icon icon="mi:chevron-down" class="flex-shrink-0" style="font-size: 1.2rem"/>
    </div>

    <!-- Dropdown -->
    <ul v-if="open" class="absolute z-10 w-full border bg-white shadow mt-1 max-h-48 overflow-auto">
      <li
          v-for="option in options"
          :key="option.value"
          class="px-3 py-2 cursor-pointer flex items-center gap-2"
          @click="toggle(option.value)"
          :class="{ selected: modelValue.includes(option.value) }"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue'

const props = defineProps({
  placeholder: {
    type: String,
    default: 'Selecione...'
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  options: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

const open = ref(false)
const containerRef = ref(null)

/**
 * Mapeia os values selecionados para objetos completos
 */
const selectedOptions = computed(() => {
  return props.options.filter(opt =>
      props.modelValue.includes(opt.value)
  )
})

/**
 * Adiciona/remove item
 */
const toggle = (value) => {
  let newValue

  if (props.modelValue.includes(value)) {
    newValue = props.modelValue.filter(v => v !== value)
  } else {
    newValue = [...props.modelValue, value]
  }

  emit('update:modelValue', newValue)
}

/**
 * Remove item
 */
const remove = (value) => {
  emit(
      'update:modelValue',
      props.modelValue.filter(v => v !== value)
  )
}

const closeDropdown = (e) => {
  if (!containerRef.value?.contains(e.target)) open.value = false
}

onMounted(() => document.addEventListener('click', closeDropdown))
onUnmounted(() => document.removeEventListener('click', closeDropdown))
</script>

<style>
.multi-select-sr {
  width: 100%;
}

.multi-select-sr ul {
  position: absolute;
  z-index: 10;
  width: 100%;
  padding: 0;
}

.multi-select-sr li {
  list-style: none;
}

.multi-select-sr li.selected,
.multi-select-sr li:hover {
  background-color: var(--fi-primary);
  color: var(--fi-white);
}
</style>
